import bg from '@/locales/bg.json'
import cs from '@/locales/cs.json'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'
import ja from '@/locales/ja.json'
import ko from '@/locales/ko.json'
import nl from '@/locales/nl.json'
import pl from '@/locales/pl.json'
import pt from '@/locales/pt.json'
import ru from '@/locales/ru.json'
import zh from '@/locales/zh.json'

export const supportedLocales = ['en', 'pl', 'de', 'fr', 'es', 'pt', 'zh', 'ru', 'it', 'ko', 'ja', 'cs', 'bg', 'nl'] as const
export const defaultLocale = supportedLocales[0]
export type Locale = typeof supportedLocales[number]

export const localeToOgLocale: Record<Locale, string> = {
  en: 'en_US',
  pl: 'pl_PL',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  pt: 'pt_PT',
  zh: 'zh_CN',
  ru: 'ru_RU',
  it: 'it_IT',
  ko: 'ko_KR',
  ja: 'ja_JP',
  cs: 'cs_CZ',
  bg: 'bg_BG',
  nl: 'nl_NL'
}

// Language selector feature flags.
// Automatically inactive when supportedLocales has only one entry.
// To explicitly disable with multiple locales, change the right-hand boolean to false.
const _languageSelectorEnabled = true
const _autoDetectLanguage = true

export const languageSelectorEnabled = supportedLocales.length > 1 && _languageSelectorEnabled
export const autoDetectLanguage = supportedLocales.length > 1 && _autoDetectLanguage

export const localeDisplayData: Record<Locale, { nativeName: string, flag: string }> = {
  en: { nativeName: 'English', flag: '🇬🇧' },
  pl: { nativeName: 'Polski', flag: '🇵🇱' },
  de: { nativeName: 'Deutsch', flag: '🇩🇪' },
  fr: { nativeName: 'Français', flag: '🇫🇷' },
  es: { nativeName: 'Español', flag: '🇪🇸' },
  pt: { nativeName: 'Português', flag: '🇵🇹' },
  zh: { nativeName: '中文', flag: '🇨🇳' },
  ru: { nativeName: 'Русский', flag: '🇷🇺' },
  it: { nativeName: 'Italiano', flag: '🇮🇹' },
  ko: { nativeName: '한국어', flag: '🇰🇷' },
  ja: { nativeName: '日本語', flag: '🇯🇵' },
  cs: { nativeName: 'Čeština', flag: '🇨🇿' },
  bg: { nativeName: 'Български', flag: '🇧🇬' },
  nl: { nativeName: 'Nederlands', flag: '🇳🇱' }
}

// vue-i18n messages — all locale JSON files bundled here
export const localeMessages = { en, pl, de, fr, es, pt, zh, ru, it, ko, ja, cs, bg, nl }
